module.exports = __webpack_public_path__ + "static/media/blank_copy_changedQ36.dcc2ec76.pdf";